<template>
  <div class="home-wrap">
    <div v-if="hasPermission">
      <el-row :gutter="30">
        <el-col :span="12" v-if="isAuth('finance:financial')">
          <!-- 饼图 Accepted Client / Pending Modified Client / Potential Client / Lost Client -->
          <accepted-client-pie></accepted-client-pie>
        </el-col>
        <el-col :span="12" v-if="isAuth('finance:financial')">
          <!-- 折线图 Accepted Client / Pending Modified Client / Potential Client / Lost Client -->
          <accepted-client-line></accepted-client-line>
        </el-col>
      </el-row>

      <el-card class="mt4 box-card">
        <div slot="header">
          <div class="customHeader">
            <el-radio-group v-model="supplierId" size="small">
              <el-radio-button :label="item.id" v-for="item in supplierList" :key="`radio-supplier-${item.id}`">
                {{ item.companyName }}
              </el-radio-button>
            </el-radio-group>
            <span class="red crp pr2 fs13" @click="clearSelectedHandle">
              <i class="fs16 el-icon-circle-close"></i>
              Clear Selected
            </span>
          </div>
        </div>

        <el-row :gutter="30">
          <el-col :span="12">
            <!-- Total Transaction / Total Turnover -->
            <total-transaction :supplierId="supplierId" ref="totalTransactionRef"></total-transaction>
          </el-col>
          <el-col :span="12">
            <!-- Total Unpaid / Total Turnover -->
            <total-unpaid :supplierId="supplierId" ref="totalUnpaidRef"></total-unpaid>
          </el-col>
          <el-col :span="12">
            <!-- Processing Time -->
            <processing-time :supplierId="supplierId"></processing-time>
          </el-col>
          <el-col :span="12">
            <!-- Statistics of Transaction Status at Each Stage -->
            <statistics-transaction-status :supplierId="supplierId" />
          </el-col>
        </el-row>

        <el-row :gutter="30">
          <el-col :span="12">
            <!-- Checker -->
            <checker :supplierId="supplierId"></checker>
          </el-col>
          <el-col :span="12">
            <!-- Reviewer -->
            <reviewer :supplierId="supplierId"></reviewer>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <engagement-trend :supplierId="supplierId"></engagement-trend>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <div v-else class="home-empty">
      <el-empty description="No viewing permission"></el-empty>
    </div>
  </div>
</template>

<script>
import TotalTransaction from "./modules/TotalTransaction";
import TotalUnpaid from "./modules/TotalUnpaid";
import ProcessingTime from "./modules/ProcessingTime";
import Checker from "./modules/Checker";
import Reviewer from "./modules/Reviewer";
import AcceptedClientPie from "./modules/AcceptedClientPie";
import AcceptedClientLine from "./modules/AcceptedClientLine";
import StatisticsTransactionStatus from "./modules/StatisticsTransactionStatus";
import EngagementTrend from "./modules/EngagementTrend";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Dashboard",
  data() {
    return {
      supplierId: "",
      supplierList: [],
      isReady: false, // 首次初始化完成后才允许 watch 生效
    };
  },
  computed: {
    ...mapGetters("authority", ["activeRoleAuthority"]),
    permissionList() {
      return this.activeRoleAuthority?.permissionList || [];
    },
    hasPermission() {
      return this.permissionList.length > 0;
    },
  },
  watch: {
    permissionList: {
      deep: true,
      handler(val) {
        // 首次进入页面期间一律跳过，仅后续切换角色等场景触发
        if (!this.isReady) return;
        if (val && val.length > 0) {
          this.$nextTick(() => {
            this.$refs.totalTransactionRef && this.$refs.totalTransactionRef.init();
            this.$refs.totalUnpaidRef && this.$refs.totalUnpaidRef.init();
          });
        }
      },
    },
  },
  components: {
    TotalTransaction,
    TotalUnpaid,
    ProcessingTime,
    Checker,
    Reviewer,
    AcceptedClientPie,
    AcceptedClientLine,
    StatisticsTransactionStatus,
    EngagementTrend,
  },
  methods: {
    ...mapActions("currency", ["getCurrencyList"]),
    // 获取供应商列表
    getSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier")
          .then(res => {
            this.supplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 查看全部供应商数据
    clearSelectedHandle() {
      this.supplierId = "";
    },
  },
  async mounted() {
    // echarts 跟随页面变化
    window.onresize = () => {
      if (document.getElementById("engagement-trend-id")) {
        this.$echarts.init(document.getElementById("engagement-trend-id")).resize();
      }
      // 敏感数据 - 财务权限
      if (this.isAuth("finance:financial")) {
        if (document.getElementById("transaction-amount")) {
          this.$echarts.init(document.getElementById("transaction-amount")).resize();
        }
        if (document.getElementById("unpaid-amount")) {
          this.$echarts.init(document.getElementById("unpaid-amount")).resize();
        }
        if (document.getElementById("clientChunk")) {
          this.$echarts.init(document.getElementById("clientChunk")).resize();
        }
        if (document.getElementById("client-quantity-line")) {
          this.$echarts.init(document.getElementById("client-quantity-line")).resize();
        }
      }
    };
    // 获取供应商列表
    this.getSupplierList();
    // 更新货币(currency)列表
    await this.getCurrencyList();
    await this.$nextTick();
    if (this.hasPermission) {
      this.$refs.totalTransactionRef.init();
      this.$refs.totalUnpaidRef.init();
    }
    this.isReady = true; // 首次初始化完成，后续 permissionList 变化交由 watch
  },
};
</script>

<style lang="scss" scoped>
.home-wrap {
  margin-left: 4px;

  .home-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 300px);
  }

  ::v-deep {
    .el-card {
      background-color: transparent !important;

      .el-card__header {
        padding: 14px 20px;

        .customHeader {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .el-radio-group {
          .el-radio-button__inner {
            color: #7987a0;
            font-size: 13px;
          }
          .el-radio-button__orig-radio:checked + .el-radio-button__inner {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>
